(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-bestseller"] && !Shopify.designMode) return;
  try {
    

(function() {


  /* =======================================================
     LAZY LOAD PANEL IMAGES
     ======================================================= */

  function loadPanelImages(panel) {

    if (!panel) {
      return;
    }


    const images = panel.querySelectorAll(
      'img[data-category-lazy="true"]'
    );


    images.forEach(function(image) {

      const src = image.dataset.src;
      const srcset = image.dataset.srcset;
      const sizes = image.dataset.sizes;


      if (sizes) {
        image.sizes = sizes;
      }


      if (srcset) {
        image.srcset = srcset;
      }


      if (src) {
        image.src = src;
      }


      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-sizes');
      image.removeAttribute('data-category-lazy');

    });

  }



  /* =======================================================
     ACTIVATE TAB
     ======================================================= */

  function activateTab(container, tab) {

    const tabs = container.querySelectorAll(
      '.category-bestseller__tab'
    );

    const panels = container.querySelectorAll(
      '.category-bestseller__panel'
    );


    tabs.forEach(function(item) {

      item.classList.remove('button--primary');

      item.classList.add('button--secondary');

      item.setAttribute('aria-selected', 'false');

      item.setAttribute('tabindex', '-1');

    });


    panels.forEach(function(panel) {

      panel.classList.remove('is-active');

      panel.hidden = true;

    });


    tab.classList.remove('button--secondary');

    tab.classList.add('button--primary');

    tab.setAttribute('aria-selected', 'true');

    tab.setAttribute('tabindex', '0');


    const targetId = tab.dataset.target;

    const target = container.querySelector(
      '#' + CSS.escape(targetId)
    );


    if (!target) {
      return;
    }


    target.hidden = false;

    target.classList.add('is-active');


    /*
      Erst jetzt werden die Produktbilder
      dieses Tabs aktiviert.
    */

    loadPanelImages(target);

  }



  /* =======================================================
     INITIALIZE SECTION
     ======================================================= */

  function initCategoryBestseller(container) {

    if (!container) {
      return;
    }


    if (
      container.dataset.categoryBestsellerInitialized === 'true'
    ) {
      return;
    }


    container.dataset.categoryBestsellerInitialized = 'true';


    const tabs = container.querySelectorAll(
      '.category-bestseller__tab'
    );


    tabs.forEach(function(tab) {


      tab.addEventListener('click', function() {

        activateTab(container, tab);

      });



      tab.addEventListener('keydown', function(event) {

        if (
          event.key !== 'ArrowLeft' &&
          event.key !== 'ArrowRight' &&
          event.key !== 'Home' &&
          event.key !== 'End'
        ) {
          return;
        }


        event.preventDefault();


        const tabArray = Array.from(tabs);

        const currentIndex = tabArray.indexOf(tab);

        let newIndex = currentIndex;


        if (event.key === 'ArrowRight') {

          newIndex =
            currentIndex === tabArray.length - 1
              ? 0
              : currentIndex + 1;

        }


        if (event.key === 'ArrowLeft') {

          newIndex =
            currentIndex === 0
              ? tabArray.length - 1
              : currentIndex - 1;

        }


        if (event.key === 'Home') {
          newIndex = 0;
        }


        if (event.key === 'End') {
          newIndex = tabArray.length - 1;
        }


        const newTab = tabArray[newIndex];


        if (newTab) {

          newTab.focus();

          activateTab(container, newTab);

        }

      });

    });

  }



  /* =======================================================
     INITIALIZE ALL SECTIONS
     ======================================================= */

  function init() {

    document
      .querySelectorAll('[id^="category-bestseller-"]')
      .forEach(function(container) {

        initCategoryBestseller(container);

      });

  }



  /* =======================================================
     DOM READY
     ======================================================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );

  } else {

    init();

  }



  /* =======================================================
     SHOPIFY THEME EDITOR
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function(event) {

      const container =
        event.target.matches &&
        event.target.matches('[id^="category-bestseller-"]')
          ? event.target
          : event.target.querySelector(
              '[id^="category-bestseller-"]'
            );


      if (container) {

        container.removeAttribute(
          'data-category-bestseller-initialized'
        );

        initCategoryBestseller(container);

      }

    }
  );


})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
